import { render, staticRenderFns } from "./TicketMessageTiptap.vue?vue&type=template&id=32dfbc50"
import script from "./TicketMessageTiptap.vue?vue&type=script&lang=js"
export * from "./TicketMessageTiptap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports